import { duration } from "@mui/material/styles";

export const TRANSITION_DURATION = duration.shorter;

export const MIN_LOADING_STATE_DURATION = 1200;
export const DEFAULT_SHOW_SUCCESS_DURATION = 2000;
export const DEFAULT_SHOW_ERROR_DURATION = Infinity;
